import MarketingLayout from '../layouts/MarketingLayout.jsx'
import SEOHead from '../components/SEOHead.jsx'

export default function PrivacyPage() {
  return (
    <MarketingLayout>
      <SEOHead
        title="Politique de confidentialité"
        description="Politique de confidentialité et RGPD de KartQuiz — données collectées, finalités, droits."
        canonical="/confidentialite"
        robots="noindex, follow"
      />

      <section className="bg-[#F8FAFC] py-16">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display font-semibold text-4xl text-kart-night mb-2">Politique de confidentialité</h1>
          <p className="text-slate-400 text-sm">Dernière mise à jour : mai 2026</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 prose prose-slate max-w-none">

          <p>
            KartQuiz est édité par BCOMING.Digital (SIRET 877 976 571 00019), Lyon (69005), France. La présente politique décrit les données personnelles collectées, les finalités de leur traitement et les droits dont tu disposes.
          </p>

          <h2>1. Données collectées</h2>

          <h3>Compte enseignant / formateur</h3>
          <ul>
            <li>Email, nom, prénom (obligatoires à la création de compte)</li>
            <li>Mot de passe haché (jamais stocké en clair)</li>
            <li>Informations de profil optionnelles : établissement, code postal, niveaux enseignés</li>
          </ul>

          <h3>Participants (élèves)</h3>
          <p>
            Les élèves ne créent pas de compte. Seul un <strong>pseudo librement choisi</strong> est demandé au moment de rejoindre une partie. Aucun email, aucun identifiant nominatif, aucun suivi persistant entre les sessions.
          </p>

          <h3>Données de jeu</h3>
          <p>
            Réponses aux questions, scores, positions sur le circuit — stockés de façon agrégée pour les statistiques pédagogiques. Ces données sont liées au pseudo anonyme du joueur, pas à une identité réelle.
          </p>

          <h2>2. Finalités du traitement</h2>
          <ul>
            <li>Permettre la création de compte et la connexion</li>
            <li>Permettre l'animation et la participation aux parties</li>
            <li>Afficher les statistiques pédagogiques après une partie</li>
            <li>Améliorer le service (statistiques d'usage agrégées, anonymisées)</li>
          </ul>

          <h2>3. Durée de conservation</h2>
          <ul>
            <li><strong>Compte enseignant</strong> : conservé tant que le compte est actif, puis 3 ans après la dernière connexion</li>
            <li><strong>Données de partie (élèves)</strong> : supprimées 30 jours après la fin de la partie</li>
            <li><strong>Logs techniques</strong> : 90 jours maximum</li>
          </ul>

          <h2>4. Tes droits (RGPD)</h2>
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD), tu disposes des droits suivants :</p>
          <ul>
            <li><strong>Accès</strong> : obtenir une copie de tes données</li>
            <li><strong>Rectification</strong> : corriger des données inexactes</li>
            <li><strong>Opposition</strong> : t'opposer à certains traitements</li>
            <li><strong>Portabilité</strong> : recevoir tes données dans un format structuré</li>
            <li><strong>Effacement</strong> : demander la suppression de tes données</li>
          </ul>
          <p>
            Pour exercer ces droits : <a href="mailto:contact@kartquiz.fr">contact@kartquiz.fr</a><br />
            Tu peux également adresser une réclamation à la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.
          </p>

          <h2>5. Sous-traitants</h2>
          <ul>
            <li><strong>Vercel Inc.</strong> (hébergement frontend, CDN) — États-Unis, accord SCCs en vigueur</li>
            <li><strong>Railway</strong> (hébergement backend) — États-Unis, accord SCCs en vigueur</li>
            <li><strong>Supabase Inc.</strong> (base de données, stockage) — région Europe (Frankfurt)</li>
            <li><strong>Fournisseur IA</strong> (génération de quiz) — les prompts envoyés ne contiennent pas de données personnelles élèves</li>
          </ul>

          <h2>6. Cookies</h2>
          <p>
            KartQuiz n'utilise <strong>aucun cookie publicitaire ou de tracking tiers</strong>. Seul un cookie de session technique est utilisé pour maintenir la connexion de l'enseignant. Aucun bandeau de consentement cookies n'est requis.
          </p>

          <h2>7. Transferts hors UE</h2>
          <p>
            Les données de la base de données sont hébergées en Europe (Frankfurt). Le frontend et le backend sont hébergés aux États-Unis sur des fournisseurs disposant de mécanismes de transfert conformes (SCCs). Si tu as des questions spécifiques sur les transferts, écris-nous à <a href="mailto:contact@kartquiz.fr">contact@kartquiz.fr</a>.
          </p>
        </div>
      </section>
    </MarketingLayout>
  )
}
